import { useMemo, useEffect } from 'react'
import UAccordionHeader from './UAccordionHeader'
import { Body, Link, StepContent, StepItem, Stepper } from '@panwds/react-ui'
import { useFormContext } from 'react-hook-form'
import type { VFC } from 'react'
import type { CommonStoreState } from '../../store'

type StepContentDataType = {
  label: string
  content: string
  link?: string
  linkHeader?: string
}

type UDeviceOnboardingStepsProps = {
  title: string
  subtitle: string
  state: CommonStoreState
  onboardingSteps?: StepContentDataType[]
  setDisable: (disable: boolean) => void
}

const defaultOnboardingSteps: StepContentDataType[] = [
  {
    label: 'If you want to manage configuration in the cloud: Move Devices to Cloud Management',
    content: 'Move devices to the cloud by following these ',
    link: 'https://docs.paloaltonetworks.com/common-services/device-associations/get-started'
  },
  {
    label: 'If you want to manage configuration in Panorama: Lorem Ipsum',
    content: 'Lorem ipsum by following these ',
    link: 'https://docs.paloaltonetworks.com/common-services/device-associations/get-started'
  },
  {
    label: 'Enable Telemetry',
    content: 'Device telemetry collects data about your device and shares it with Palo Alto Networks by uploading the data to Strata Logging Service. Enable telemetry on the device by following these ',
    link: 'https://docs.paloaltonetworks.com/pan-os/10-0/pan-os-admin/device-telemetry/device-telemetry-configure/device-telemetry-enable'
  }
]

const defaultProps = {
  title: 'Device Onboarding Steps',
  subtitle: (<>
    <Body addClassName='cm-pr-1' appearance='secondary' as='span'>{'You can view the list of devices in the customer support portal.'}</Body>
    <Body addClassName='cm-pl-1' appearance='secondary' as='span'>{'To get the most of the product, follow the onboarding steps below. You can complete these onboarding steps after you finish product activation.'}</Body>
  </>)
}

const UDeviceOnboardingSteps: VFC<UDeviceOnboardingStepsProps> = (props) => {
  const { title, state, subtitle, setDisable, onboardingSteps } = props
  const { formState } = useFormContext()
  const { errors = {} } = formState
  useEffect(() => {
    if (state.supportAccountId && (state.tsg || state.tsgs[0].children?.length === 0) && !errors?.TSG_BANNER) {
      setDisable(false)
    }
    else {
      setDisable(true)
    }
  }, [errors?.TSG_BANNER, setDisable, state.supportAccountId, state.tsg, state.tsgs])

  const getOnboardingSteps = useMemo(() => {
    const _onboardingSteps = onboardingSteps ?? defaultOnboardingSteps
    return (
      <Stepper vSpacing="tw-h-auto tw-mb-4" direction="vertical">
        {_onboardingSteps?.map(({ label }, index) => (
          <StepItem key={`device-step-${index}`} status={'inactive'} index={index}>
            <StepContent label={label} content={
              (
                <>
                  {_onboardingSteps[index]?.content}
                  {Boolean(_onboardingSteps[index]?.link) && <Link href={_onboardingSteps[index]?.link} external>
                    {Boolean(_onboardingSteps[index]?.linkHeader) ? _onboardingSteps[index]?.linkHeader : 'steps'}
                  </Link>}
                </>
              )
            } size="xs" />
          </StepItem>))}
      </Stepper>
    )
  }, [onboardingSteps])

  return (
    <div>
      <UAccordionHeader title={title} subtitle={subtitle ?? defaultProps.subtitle} />
      {getOnboardingSteps}
    </div>
  )

}

export default UDeviceOnboardingSteps
